export const AIRPORT_LIST_ACTION = "AIRPORT_LIST_ACTION";
export const AIRPORT_LIST_SUCCESS = "AIRPORT_LIST_SUCCESS";
export const AIRPORT_LIST_FAIL = "AIRPORT_LIST_FAIL";
export const AIRPORT_DELETE_TRANSLATE_SUCCESS = "AIRPORT_DELETE_TRANSLATE_SUCCESS";

export const AIRPORT_DETAIL_ACTION = "AIRPORT_DETAIL_ACTION";
export const AIRPORT_DETAIL_DELETE_ACTION = "AIRPORT_DETAIL_DELETE_ACTION";
export const AIRPORT_DETAIL_SUCCESS = "AIRPORT_DETAIL_SUCCESS";
export const AIRPORT_DETAIL_FAIL = "AIRPORT_DETAIL_FAIL"

export const AIRPORT_DETAIL_UPDATE_ACTION = "AIRPORT_DETAIL_UPDATE_ACTION";
export const AIRPORT_DETAIL_CREATE_ACTION = "AIRPORT_DETAIL_CREATE_ACTION";

export const AIRPORT_CREATE_TRANSLATE_ACTION = "AIRPORT_CREATE_TRANSLATE_ACTION";
export const AIRPORT_UPDATE_TRANSLATE_ACTION = "AIRPORT_UPDATE_TRANSLATE_ACTION";
export const AIRPORT_DELETE_TRANSLATE_ACTION = "AIRPORT_DELETE_TRANSLATE_ACTION";

export const AIRPORT_CREATE_TRANSLATE_SUCCESS = "AIRPORT_CREATE_TRANSLATE_SUCCESS";
export const AIRPORT_UPDATE_TRANSLATE_SUCCESS = "AIRPORT_UPDATE_TRANSLATE_SUCCESS";
export const AIRPORT_FAIL = "AIRPORT_FAIL";

export const AIRLINE_LIST_DOMESTIC_ACTION = "AIRLINE_LIST_DOMESTIC_ACTION";
export const AIRLINE_LIST_DOMESTIC_SUCCESS = "AIRLINE_LIST_DOMESTIC_SUCCESS";
export const AIRLINE_LIST_DOMESTIC_FAIL = "AIRLINE_LIST_DOMESTIC_FAIL";

export const AIRPORT_LIST_DEPARTURE_ACTION = "AIRPORT_LIST_DEPARTURE_ACTION";
export const AIRPORT_LIST_DEPARTURE_SUCCESS = "AIRPORT_LIST_DEPARTURE_SUCCESS";
export const AIRPORT_LIST_DEPARTURE_FAIL = "AIRPORT_LIST_DEPARTURE_FAIL";

export const AIRPORT_LIST_ARRIVAL_ACTION = "AIRPORT_LIST_ARRIVAL_ACTION";
export const AIRPORT_LIST_ARRIVAL_SUCCESS = "AIRPORT_LIST_ARRIVAL_SUCCESS";
export const AIRPORT_LIST_ARRIVAL_FAIL = "AIRPORT_LIST_ARRIVAL_FAIL";

export const TOAIRPORT_LIST_ACTION = "TOAIRPORT_LIST_ACTION";
export const TOAIRPORT_LIST_SUCCESS = "TOAIRPORT_LIST_SUCCESS";
export const TOAIRPORT_LIST_FAIL = "TOAIRPORT_LIST_FAIL"
export const TOAIRPORT_LIST_CREATE_ACTION = "TOAIRPORT_LIST_CREATE_ACTION";
export const TOAIRPORT_LIST_UPDATE_ACTION = "TOAIRPORT_LIST_UPDATE_ACTION";

export const AIRLINE_SOURCE_UPDATE = "AIRLINE_SOURCE_UPDATE";
export const AIRLINE_SOURCE_UPDATE_SUCCESS = "AIRLINE_SOURCE_UPDATE_SUCCESS";
export const AIRLINE_SOURCE_GET = "AIRLINE_SOURCE_GET";
export const AIRLINE_SOURCE_SET = "AIRLINE_SOURCE_SET";